import Swiper, { Navigation, Scrollbar } from 'swiper'

import './destination-slider.scss'

const initFormulaSlider = (container) => {
  new Swiper(container.querySelector('.swiper'), {
    modules: [Navigation, Scrollbar],

    enabled: false,
    slidesPerView: 'auto',

    scrollbar: {
      el: container.querySelector('.swiper-scrollbar'),
      draggable: true,
    },

    navigation: {
      prevEl: container.querySelector('.prev'),
      nextEl: container.querySelector('.next'),
    },

    breakpoints: {
      1024: {
        enabled: container.classList.contains('ds_columns-4'),
        spaceBetween: container.classList.contains('ds_columns-4') ? 8 : 0,
        slidesPerView: container.classList.contains('ds_columns-4') ? 4 : 'auto',
      },
    },
  })
}

document.addEventListener(
  'DOMContentLoaded',
  async function () {
    const containers = document.querySelectorAll('.ds')

    containers?.forEach(initFormulaSlider)
  },
  { once: true }
)
